import { ChevronDownIcon, HamburgerIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Context/AuthProvider";
import CustomModal from "../Common/CustomModal/CustomModal.jsx";
import SignOutModal from "../Common/SignOutModal";
import HelpForm from "./HelpForm";

const Navbar = () => {
  const { isAuthenticated, isAdmin, isImportUser } = useContext(AuthContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isHelpModalOpen,
    onClose: onHelpModalClose,
    onOpen: onHelpModal,
  } = useDisclosure();

  const {
    isOpen: isDrawerOpen,
    onOpen: onDrawerOpen,
    onClose: onDrawerClose,
  } = useDisclosure();

  return (
    <Box bg="bgColor" color="textColor" px={4} py={2}>
      <Flex h={16} alignItems="center" justifyContent="space-between">
        <Box display="flex" gap={2} alignItems="center">
          <Image
            src="https://i.imgur.com/jqxorjP.png"
            height={{ base: "45px", md: "70px" }}
            // width={{ base: "45px", md: "70px" }}

            alt="logo"
          />
          {/* <Text
            fontSize={{ base: "sm", md: "lg" }}
            fontWeight={700}
            lineHeight={{ base: "md", md: "xl" }}
          >
            Great Plains <br /> Tribal Leaders Health Board
          </Text> */}
        </Box>

        {/* Desktop Navigation */}
        <Box display={{ base: "none", md: "flex" }} alignItems="center" gap={4}>
          {Array.from(["Home", "Investigate", "Monitor", "Source"]).map(
            (item, index) => (
              <Link to={`${index === 0 ? "/" : "/" + item}`} key={index}>
                <Text color="textColor" px={2} py={1} rounded="md">
                  {item}
                </Text>
              </Link>
            ),
          )}
          {isImportUser && (
            <Link to="/Import-roster">
              <Text color="textColor" px={2} py={1} rounded="md">
                Import Roster
              </Text>
            </Link>
          )}
          {isAuthenticated && isAdmin && (
            <Link to="/Admin">
              <Text color="textColor" px={2} py={1} rounded="md">
                Admin
              </Text>
            </Link>
          )}
          {isAuthenticated && (
            <Button variant="primaryButton" onClick={onOpen}>
              Sign out
            </Button>
          )}

          <Menu>
            <MenuButton size="sm" as={Button} rightIcon={<ChevronDownIcon />}>
              Help
            </MenuButton>
            <MenuList bg="#EFEFF5">
              <MenuItem
                onClick={() => {
                  onHelpModal();
                  onDrawerClose();
                }}
                bg="#EFEFF5"
                color="black"
                _hover={{ background: "black", color: "white" }}
                borderBottom="1px solid black"
              >
                Report
              </MenuItem>
              <Link
                to="https://wintercountfaq.gpthd.org/winter_count_help.html#welcome"
                target="_blank"
              >
                <MenuItem
                  color="black"
                  bg="#EFEFF5"
                  _hover={{ background: "black", color: "white" }}
                  borderBottom="1px solid black"
                >
                  FAQ
                </MenuItem>
              </Link>
            </MenuList>
          </Menu>
        </Box>

        {/* Mobile Hamburger Menu */}
        <Box display={{ base: "block", md: "none" }}>
          <IconButton
            icon={<HamburgerIcon />}
            variant="primary"
            aria-label="Open Menu"
            onClick={onDrawerOpen}
          />
        </Box>
      </Flex>

      {/* Mobile Drawer */}
      <Drawer isOpen={isDrawerOpen} placement="left" onClose={onDrawerClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader> Winter Count</DrawerHeader>
          <DrawerBody>
            <VStack align="start" spacing={4}>
              {Array.from([
                "Home",
                "Import-roster",
                "Investigate",
                "Monitor",
                "Source",
              ]).map((item, index) => (
                <Link to={`${index === 0 ? "/" : "/" + item}`} key={index}>
                  <Text
                    color="black"
                    px={2}
                    py={1}
                    rounded="md"
                    onClick={onDrawerClose}
                  >
                    {item}
                  </Text>
                </Link>
              ))}
              {isAuthenticated && isAdmin && (
                <Link to="/Admin">
                  <Text px={2} py={1} onClick={onDrawerClose}>
                    Admin
                  </Text>
                </Link>
              )}

              <Menu>
                <MenuButton as={Button} rightIcon={<ChevronDownIcon />}>
                  Help
                </MenuButton>
                <MenuList bg="#EFEFF5">
                  <MenuItem
                    onClick={() => {
                      onHelpModal();
                      onDrawerClose();
                    }}
                    bg="#EFEFF5"
                    _hover={{ background: "black", color: "white" }}
                    borderBottom="1px solid black"
                  >
                    Help Form
                  </MenuItem>
                  <Link
                    to="https://wintercountfaq.gpthd.org/winter_count_help.html#welcome"
                    target="_blank"
                  >
                    <MenuItem
                      onClick={() => {
                        onDrawerClose();
                      }}
                      color="black"
                      bg="#EFEFF5"
                      _hover={{ background: "black", color: "white" }}
                      borderBottom="1px solid black"
                    >
                      FAQ
                    </MenuItem>
                  </Link>
                </MenuList>
              </Menu>

              {/* <Button size="sm">Help</Button> */}
              {!isAuthenticated && (
                <Button
                  variant="primaryButton"
                  onClick={() => {
                    onOpen();
                    onDrawerClose();
                  }}
                >
                  Sign out
                </Button>
              )}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      {/* Modals */}
      <SignOutModal onClose={onClose} isOpen={isOpen} />
      <CustomModal
        size="3xl"
        h="2xl"
        isCentered={false}
        title="Help"
        isOpen={isHelpModalOpen}
        onClose={onHelpModalClose}
        bodyContent={<HelpForm onHelpModalClose={onHelpModalClose} />}
      />
    </Box>
  );
};

export default Navbar;
